import { CardElement, Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { CardForm } from ".";
import { useApplicationStore } from "../../context/ApplicationStoreContext";

const stripePromise = loadStripe(
  "pk_test_51JNTRhG3mczfCHwAleVYZQOy5xjEEe7AEStbzD48OpoVDcWgMTLSiZJBEciHAKSjOkLEfcQoKdxfEdmbiM2QN4SH00aCdYdn9v"
);

const PaymentInfo = () => {
  const [clientSecret, setClientSecret] = useState<string>();
  const { state, dispatch } = useApplicationStore();
  useEffect(() => {
    setClientSecret(state.paymentInfo?.clientSecret!);
  }, [state.paymentInfo]);

  const options = {
    clientSecret,
  };

  return (
    <>
      {clientSecret && (
        <Elements stripe={stripePromise} options={options}>
          <CardForm/>
        </Elements>
      )}
    </>
  );
};

export default PaymentInfo;
